import classNames from "classnames";
import { ReactComponent as ThumbIcon } from "shared/assets/Icons/thumb.svg";
import { useTranslation } from "react-i18next";

interface ExperienceFeedbackProps {
  message?: string;
  positiveLabel?: string;
  negativeLabel?: string;
  onPositive: () => any;
  onNegative: () => any;
}

export const ExperienceFeedback = ({ message, positiveLabel, negativeLabel, onPositive, onNegative }: ExperienceFeedbackProps) => {
  const { t } = useTranslation();

  const getIconClasses = (colorClass: string) => classNames("flex items-center justify-center rounded-full shrink-0 w-14 h-14", colorClass);

  return (
    <>
      <h2>{message || t("experienceModal.title")}</h2>
      <div className="flex justify-center items-start gap-10 mb-10">
        <button
          data-testid="positive-experience"
          aria-label={positiveLabel ? undefined : t("experienceModal.thumbs-up")}
          onClick={onPositive}
          className="group flex flex-col items-center gap-2"
        >
          <span className={getIconClasses("bg-brand-green group-hover:bg-brand-green-light")}>
            <ThumbIcon aria-hidden="true" />
          </span>
          {positiveLabel && <span className="font-bold">{positiveLabel}</span>}
        </button>
        <button
          data-testid="negative-experience"
          aria-label={negativeLabel ? undefined : t("experienceModal.thumbs-down")}
          onClick={onNegative}
          className="group flex flex-col items-center gap-2"
        >
          <span className={getIconClasses("bg-brand-grey group-hover:bg-brand-grey-light")}>
            <ThumbIcon aria-hidden="true" className="rotate-180" />
          </span>
          {negativeLabel && <span className="font-bold">{negativeLabel}</span>}
        </button>
      </div>
    </>
  );
};
